import { Button } from 'components/dynamic-content/button';
import React from 'react';
import { MaxWidthContainer } from './max-width-container';

interface IProps {
  explorePageLink: string;
}

const utmParams = '&utm_content=browse-all-cta';

export const BrowseAll: React.FC<IProps> = ({ explorePageLink }) => (
  <MaxWidthContainer className='flex flex-row place-content-center'>
    <Button link={`${explorePageLink}${utmParams}`} text='Browse All' includeArrow={false} />
  </MaxWidthContainer>
);
